export const Blinker = (data) => {
    return {
      type: 'Blinker',
      payload: data
    }
}
